module.exports = __webpack_public_path__ + "static/media/r194.77822503.jpg";